export default "__VITE_ASSET__BgZwC0IE__"